import Vue from 'vue';
import { gsap } from 'gsap';
// eslint-disable-next-line import/no-extraneous-dependencies
import imagesLoaded from 'imagesloaded';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('scroll-indicator-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            scrollIndicator: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        imagesLoaded('#app', () => {
            Vue.nextTick(() => {
                this.initScrollTrigger();
            });
        });

        EventBus.$on('refresh-scroll-indicator', this.initScrollTrigger);
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initScrollTrigger() {
            if (window.matchMedia('(min-width: 1024px)').matches) {
                this.scrollIndicator = gsap.to('.header__scrollbar-indicator', {
                    scaleY: 1,
                    ease: 'none',
                    scrollTrigger: { scrub: 0.1 },
                });
            } else {
                this.scrollIndicator = gsap.to('.header__scrollbar-indicator', {
                    scaleX: 1,
                    ease: 'none',
                    scrollTrigger: { scrub: 0.1 },
                });
            }
        },

        refreshScrollTrigger() {
            this.tweenScrollTrigger.refresh();
        },
    },
});
